import classNames from "classnames";
import NumberFormat from "react-number-format";
import { UserIcon } from "@heroicons/react/24/outline";
import CiroTooltipContainer from "./CiroTooltipContainer";

const CiroContactPill = ({
  amount,
  additionalText,
  customColor,
  customBackgroundColor,
  showContactExplanationTooltip,
}: {
  amount: number;
  additionalText?: string;
  customColor?: string;
  customBackgroundColor?: string;
  showContactExplanationTooltip?: boolean;
}) => {
  const content = (
    <span
      className={classNames(
        "flex",
        "items-center",
        "rounded",
        "px-1",
        "text-sm",
        {
          "text-blue-500": !customColor,
          "bg-blue-100": !customBackgroundColor,
        },
        customColor,
        customBackgroundColor,
      )}
    >
      {additionalText && (
        <span className={classNames("pr-1")}>{additionalText}</span>
      )}
      <NumberFormat displayType="text" thousandSeparator="," value={amount} />
      <span className={classNames("pl-1")}>
        <UserIcon className="h-4 w-4" />
      </span>
    </span>
  );

  const tooltip = showContactExplanationTooltip
    ? "Each searched contact depletes 1 from balance. Resets each month."
    : undefined;

  return (
    <CiroTooltipContainer tooltip={tooltip}>{content}</CiroTooltipContainer>
  );
};

export default CiroContactPill;
